"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMarket = exports.getDefaultTimeInForce = void 0;
const order_1 = require("../modules/order");
const getDefaultTimeInForce = (isMarketOrder) => {
    return isMarketOrder ? order_1.OrderModule.TimeInForce.Ioc : order_1.OrderModule.TimeInForce.Gtc;
};
exports.getDefaultTimeInForce = getDefaultTimeInForce;
function isMarket(type) {
    const newType = type;
    return newType === order_1.OrderModule.OrderType.Market || newType === order_1.OrderModule.OrderType.StopMarket || newType === order_1.OrderModule.OrderType.TakeProfitMarket;
}
exports.isMarket = isMarket;
